// /src/store/modules/posts.js
import forEach from 'lodash/forEach'
import map from 'lodash/map'
import cloneDeep from 'lodash/cloneDeep'
import remove from 'lodash/remove'
import some from 'lodash/some'
import _reverse from 'lodash/reverse'
import _isInteger from 'lodash/isInteger'
import uniq from 'lodash/uniq'
import isUndefined from 'lodash/isUndefined'
import isArray from 'lodash/isArray'
import _uniqWith from 'lodash/uniqWith'
import _isEqual from 'lodash/isEqual'
import create from 'lodash/create'

import CommonGetters from '@/store/common/getters'
import { apiGet, futureDate, getPage } from '@/services/API'
import { getCustomAPIPage } from '@/services/CustomAPIService'
import { pStore } from '@/services/Storage'

import { checkNested } from '@/components/common/utils/helpers.js'
import { deepSearch } from '../../components/common/utils/helpers'



export const namespaced = true

let postPolling = null

export const state = {
  currentAPIRun: 0,
  nextAPIRun: 0,
  staleDataDate: 0,
  singlePostRequestTriggered: false,
  getAllPostRequestTriggered: false,
  courses: {
    data: [],
    queryRun: false,
  },
  searchResults: {
    data: [],
    queryRun: false,
  },
  sessions: {
    data: [],
    queryRun: false,
  },
  bookmarks: {
    data: [],
    queryRun: false,
  },
  relationships: {
    data: [],
    queryRun: false,
  },
  bibleStudies: {
    data: [],
  },
  funnels: {
    data: [],
  },
  funnelImages: {
    data: [],
  },
  funnelLandingPages: {
    data: [],
  },
  errors: {
    responses: [],
    status: [],
    timers: [5000, 15000, 61000],
    count: 0,
  },
}

export const mutations = {
  SET_CURRENT_API_RUN(state, date) {
    state.currentAPIRun = date
  },
  SET_API_NEXT_RUN(state, date) {
    state.nextAPIRun = date
  },
  SET_API_STALE_DATA_DATE(state, date) {
    state.staleDataDate = date
  },
  SET_POLL(state, poll) {
    state.polling = poll
  },
  SET_SESSIONS(state, sessions) {
    // if (typeof state.sessions.title != 'undefined') {
    //   state.sessions.data = _uniqWith([
    //     ...state.sessions.data,
    //     ...sessions.data,
    //   ], session => {
    //     return session.id})
    // } else {
      state.sessions = sessions
    // }
  },
  SET_RELATIONSHIPS(state, sessions) {
    state.relationships = sessions
  },
  SET_CONTENT_DATA(state, contentData) {
    const { key, data } = contentData
    state[key].data = data
  },
  SET_SEARCH_RESULTS(state, searchResults) {
    state.searchResults = searchResults
  },

  SET_BOOKMARKS(state, bookmarks) {
    state.bookmarks = bookmarks
  },

  SET_COURSES(state, courses) {
    state.courses = courses
  },
  SET_BIBLE_STUDIES(state, bibleStudies) {
    state.bibleStudies = bibleStudies
  },
  SET_FUNNELS(state, funnels) {
    state.funnels = funnels
  },
  SET_FUNNELS(state, funnels) {
    state.funnels = funnels
  },
  SET_FUNNELIMAGES(state, funnelImages) {
    state.funnelImages.data = funnelImages
  },
  SET_FUNNEL_LANDING_PAGES(state, funnelLandingPages) {
    state.funnelLandingPages = funnelLandingPages
  },
  SET_ERROR(state, error) { 
    state.errors.responses.push(error)
  },
  COUNT_ERRORS(state, count) {
    state.errors.count++
  },
  CLEAR_ERRORS(state) {
    state.errors.responses = []
  },
  SET_SINGLE_POST_REQUESTED(state, bool) {
    state.singlePostRequestTriggered = bool
  },
  SET_GET_ALL_POSTS_REQUESTED(state, bool) {
    state.getAllPostRequestTriggered = bool
  },
}

export const actions = {
  checkUserNull({ dispatch, rootState }) {
    if (
      rootState.user.user !== null &&
      !dispatch('user/expire', null, { root: true })
    ) {
      return false
    } else {
      return true
    }
  },

  getPostLists({ dispatch }, query = {}) {
    if (dispatch('checkUserNull')) dispatch('requestPostList', query)
  },

  getPost({ dispatch }, post = {}) {
    if (dispatch('checkUserNull')) dispatch('requestPost', post)
  },

  getDashboards({ dispatch }) {
    if (dispatch('checkUserNull')) dispatch('requestDashboards')
  },

  getAll({ dispatch }) {
    if (dispatch('checkUserNull')) dispatch('requestPosts')
  },

  getBookmarks({ dispatch, rootGetters }, searchQuery = {}) {
    const bookmarkArray = rootGetters['user/getBookmarks'].map(
      item => item.id,
    )
    searchQuery['include'] = bookmarkArray.join(',')

    if (dispatch('checkUserNull') && searchQuery['include'] != '') dispatch('requestBookmarks', searchQuery)
  },

  runSearch({ dispatch, rootState, state }, searchQuery = {}) {
    if (state.searchResults.queryRun == true) return
    if (dispatch('checkUserNull')) dispatch('requestSearch')
  },

  async getRelatedPosts({ commit, dispatch, rootState }, posts = {}) {
    const apiRequests = pStore.apiRequests
    const userGroups = rootState.user.groups
    const apiRequest = apiRequests.find(item => item.routePath == posts.routePath)

    if (typeof posts.routePath != 'undefined') delete posts.routePath

    try {
      let morePages = true
      // posts.page = 2
      let page = 1
      let totalPages = 1
      let data = []
      // const {totalPages, ...args} = posts
      while (morePages) {
        const response = await getPage(apiRequest.routePath, {...posts})
        if (response.status >= 200 && response.status < 300) {
          data.push(...response.data)
          totalPages = parseInt(response.headers['x-wp-totalpages'])
          morePages = page < totalPages
          page++
          posts.page = page
        } else {
          commit('SET_ERROR', res)
          dispatch('handleRequestErrors')
        }
      }
      const stateItem = {
        'data': [],
      }

      stateItem['data'] = filterUserData(userGroups, data)
      commit(apiRequest.stateCommit, stateItem)

    } catch (err) {
      // dispatch('polling', false)
      console.log(err)
    }

  },

  async requestSearch({ commit, dispatch, rootState }, searchQuery = {}) {
    const apiRequests = pStore.apiRequests
    const userGroups = rootState.user.groups

    // let args = {
    //   // per_page: 20,
    //   // ...searchQuery
    // }

    // if (args.hasOwnProperty('page') && args.page <= 1) delete args.page
    
    try {
      const res = await getCustomAPIPage('search')
      // get first of status to see if server or client error
      if (res.status >= 200 && res.status < 300) {
        const stateItem = {
          'data': [],
        }
        const filteredData = filterUserData(userGroups, res.data)
        
        stateItem['data'] = filteredData.map( item => {
          return {
            ...item,
            id: item.ID,
          }
        })
        
        stateItem['queryRun'] = true
        commit('SET_SEARCH_RESULTS', stateItem)

      } else {
        commit('SET_ERROR', res)
        dispatch('handleRequestErrors')
      }

    } catch (err) {
      // dispatch('polling', false)
      console.log(err)
    }

  },

  async requestBookmarks({ commit, dispatch, rootState }, searchQuery = {}) {
    const userGroups = rootState.user.groups

    let args = {
      ...searchQuery
    }

    commit('SET_BOOKMARKS', {
      data: [],
    })
    
    if (args.hasOwnProperty('page') && args.page <= 1) delete args.page
    
    try {
      const res = await getCustomAPIPage('search', {...args})

      // get first of status to see if server or client error
      if (res.status >= 200 && res.status < 300) {
        const stateItem = {
          'data': [],
        }
        const filteredData = filterUserData(userGroups, res.data)
        
        stateItem['data'] = filteredData.map( item => {
          return {
            ...item,
            id: item.ID,
          }
        })
        
        stateItem['queryRun'] = true
        commit('SET_BOOKMARKS', stateItem)

      } else {
        commit('SET_ERROR', res)
        dispatch('handleRequestErrors')
      }

    } catch (err) {
      // dispatch('polling', false)
      console.log(err)
    }

  },

  async requestPostList({ commit, dispatch, rootState }, searchQuery = {}) {
    const apiRequests = pStore.apiRequests
    const userGroups = rootState.user.groups
    const apiRequest = apiRequests.find(item => item.routePath == searchQuery.routePath)
    const { query } = searchQuery

    let args = {
      per_page: 28,
      // orderby: 'menu_order', 
      // order: 'asc',
      status: 'publish',
      ...query,
    }


    // adjust post list to show searching not error when looking for content.
    commit(apiRequest.stateCommit, {
      data: [],
    })

    if (args.hasOwnProperty('page') && args.page <= 1) delete args.page
    // delete args['sort']
    try {
      const res = await getPage(apiRequest.routePath, {...args})

      if (res.status >= 200 && res.status < 300) {
        const stateItem = {
          'data': [],
        }
        
        stateItem['data'] = filterUserData(userGroups, res.data)
        stateItem['per_page'] = args.per_page
        stateItem['totalPages'] = res.headers['x-wp-totalpages']
        stateItem['query'] = args
        stateItem['queryRun'] = true
        commit(apiRequest.stateCommit, stateItem)
      } else {
        commit('SET_ERROR', res)
        dispatch('handleRequestErrors')
      }

    } catch (err) {
      // dispatch('polling', false)
      console.log(err)
    }

  },

  // async getQueryNames({rootGetters}, query = {}) {
  //   await Promise.all(
  //     const taxies = await rootGetters['taxies/filterItemsByProp'](
  //       type,
  //       numberValue,
  //     )

  //   )
  
  // },

  async requestPost({ commit, dispatch, rootState }, post = {}, getRelated = true) {
    const apiRequests = pStore.apiRequests
    // const varData = pStore.varData
    const userGroups = rootState.user.groups
    const apiRequest = apiRequests.find(item => item.routePath == post.routePath)

    let args = {
      orderby: 'menu_order', 
      order: 'asc',
      status: 'publish',
    }

    // console.log(args)

    try {
      const res = await getPage(apiRequest.apiPath, {...post, ...args})


      // get first of status to see if server or client error
      if (res.status >= 200 && res.status < 300) {
        const stateItem = {}
        stateItem['data'] = filterUserData(userGroups, res.data)

        if (getRelated && apiRequest['storeKey'] == 'sessions') {
          stateItem['data'].forEach(async session => {
            if (checkNested(session, 'acf', 'related_content') && isArray(session.acf.related_content)) {
              if (typeof session.related_content_objs == 'undefined') session.related_content_objs = {}
              session.related_content[0].forEach(relatedID => {
                session.related_content_objs[relatedID] = {}
              })
              // organize look up to limit api calls
              const relatedObjs = []
              session.acf.related_content.forEach(related => {
                const type = related.post_type == 'session' ? 'sessions' : related.post_type == 'course' ? 'courses' : related.post_type

                if (typeof relatedObjs[type] == 'undefined') relatedObjs[type] = []
                relatedObjs[type].push(related.ID)
              })
              // get related posts
              Object.keys(relatedObjs).map(async key => {
                const related = await getPage(key, { include: relatedObjs[key].join(',') })
                const filteredRelated = filterUserData(userGroups, related.data)
                filteredRelated.map(related => {
                  session.related_content_objs[related.id] = related
                })
              })
            }
          })
        }

        // check if courses have sections and if so get those posts
        if (apiRequest['storeKey'] == 'courses') {
          if (checkNested(stateItem['data'][0], 'acf', 'section_collection')) {
            var relatedSessions = []
            stateItem['data'].forEach( course => {
              course.acf.section_collection.forEach( section => {
                console.log(section)
                if (section.children) relatedSessions = [...relatedSessions, ...section.children]
              })             
            })
            const totalPages = Math.ceil(relatedSessions.length / 100)
            dispatch('getRelatedPosts', { routePath: 'sessions', include: relatedSessions.join(','), totalPages })
          }
          if (checkNested(stateItem['data'][0], 'collection_lists')) {
            stateItem['data'].forEach( course => {
              course.collection_lists.forEach( collection_list => {
                // console.log(collection_list)
              })             
            })
          }
        }

        stateItem['title'] = apiRequest['title']
        stateItem['storeKey'] = apiRequest['storeKey']
        stateItem['routePath'] = apiRequest['routePath']
        stateItem['titlePlural'] = apiRequest['titlePlural']

        commit(apiRequest.stateCommit, stateItem)
      } else {
        commit('SET_ERROR', res)
        dispatch('handleRequestErrors')
      }

    } catch (err) {
      // dispatch('polling', false)
      console.log(err)
    }

  },

  async requestDashboards({ commit, dispatch, rootState }, post = {}) {
    const varData = pStore.varData
    const userGroups = rootState.user.groups

    Object.keys(varData).map(key => {
      try {
        const config = varData[key]
        const stateItem = {}
        stateItem['title'] = config['title']
        stateItem['storeKey'] = config['storeKey']
        stateItem['titlePlural'] = config['titlePlural']
        // cloning data keeps original data in tact for 
        stateItem['data'] = config['storeKey'] == 'funnels' ? filterUserFunnels(userGroups, cloneDeep(config['data'])) : cloneDeep(config['data'])
        
        if (config['storeKey'] == 'funnels') {
          dispatch('bgImagePrep', map(stateItem['data'], funnel => funnel.bg_image))
        }
        commit(config.stateCommit, stateItem)

      } catch (err) {
        console.log(err)
      }
    })

  },

  async requestPosts({ commit, dispatch, rootState, state }, args = {}) {
    dispatch('setGetAllPostsTriggered')
    const apiRequests = pStore.apiRequests
    const varData = pStore.varData
    const userGroups = rootState.user.groups
    args = {
      orderby: 'menu_order', 
      order: 'asc', 
      status: 'publish',
    }

    Object.keys(varData).map(key => {
      try {
        const config = varData[key]
        const stateItem = {}
        stateItem['title'] = config['title']
        stateItem['storeKey'] = config['storeKey']
        stateItem['titlePlural'] = config['titlePlural']
        // cloning data keeps original data in tact for 
        stateItem['data'] = config['storeKey'] == 'funnels' ? filterUserFunnels(userGroups, cloneDeep(config['data'])) : cloneDeep(config['data'])
        if (config['storeKey'] == 'funnels') {
          dispatch('bgImagePrep', map(stateItem['data'], funnel => funnel.bg_image))
        }
        commit(config.stateCommit, stateItem)

      } catch (err) {
        console.log(err)
      }
    })
    await Object.keys(apiRequests).map(async key => {
      try {
        const config = apiRequests[key]

        const res = await apiGet(config.apiPath, args)
        // get first of status to see if server or client error
        if (typeof res.status != 'undefined' && res.status <= 200 && res.status < 300) {
          const stateItem = {}
          stateItem['data'] = filterUserData(userGroups, res.data)

          if (config['storeKey'] == 'sessions' && stateItem['data'].length == 0) {
            dispatch('user/logout', null, { root: true })
          }
          stateItem['title'] = config['title']
          stateItem['storeKey'] = config['storeKey']
          stateItem['routePath'] = config['routePath']
          stateItem['titlePlural'] = config['titlePlural']
          // if (config['storeKey'] == 'relationships') {
          //   stateItem.data.forEach(relationship => {
          //     if (relationship.id == 1399) console.log(relationship.id)
          //   })
          // }
          commit(config.stateCommit, stateItem)
        } else {
          commit('SET_ERROR', res)
          dispatch('handleRequestErrors')
        }
        if (key == apiRequests.length - 1) {
          dispatch('updateAPIRunTimes')
        }
      } catch (err) {
        // dispatch('polling', false)
        console.log(err)
      }
    })
  },

  setGetAllPostsTriggered({commit}) {
    commit('SET_GET_ALL_POSTS_REQUESTED', true)
  },

  bgImagePrep({commit}, images) {
    commit('SET_FUNNELIMAGES', uniq(images))
  },

  handleRequestErrors({state, commit, dispatch}) {
    const { errors } = state
    if (errors.responses.length > 0) {
      // consolidate errors into like status so all requests return as 1
      const errorStati = uniq(map(errors.responses, 'status'))
      forEach(errorStati, status => {

        // get first of status to see if server or client error
        // const statusStartsWith = parseInt(status.toString()[0]);
        
        if (status == 403) { // forbidden error has token expired
          // check if token has expired and log user out
          dispatch('user/expire', null, { root: true })
        } else if (status >= 400 && status < 500) { // handle server based errors
          dispatch(
            'notification/add',
            {
              type: 'error',
              msg: `Whoops! Looks like we lost some content.`,
              closable: false,
              autoClose: true,
            },
            { root: true },
          )
        } else if (status < 500) { // handle server based errors
          const errorCount = errors.count
          const timer = errors.timers[errorCount]
          const timerDisplay = timer/1000 + ' secs'

          if (!isUndefined(timer)) {
            dispatch(
              'notification/add',
              {
                type: 'error',
                msg: `Unfortunately the server is having issues. Please wait ${timerDisplay} while we attempt again.`,
                closable: false,
                autoClose: true,
              },
              { root: true },
            )
            setTimeout(() => {
              dispatch('requestPosts')
            }, timer)
          } else {
            dispatch(
              'notification/add',
              {
                type: 'error',
                msg: `Please manually refresh!`,
                closable: true,
                autoClose: false,
              },
              { root: true },
            )

          }
          commit('COUNT_ERRORS');
        }
      })
      commit('CLEAR_ERRORS')
    }
  },

  updateAPIRunTimes({ commit }) {
    const requestDateTime = new Date().getTime()
    commit('SET_CURRENT_API_RUN', requestDateTime)
    commit('SET_API_NEXT_RUN', futureDate(requestDateTime))
    commit('SET_API_STALE_DATA_DATE', futureDate(requestDateTime, 43200)) // 43200 == 30 days
  },
}

function filterUserData(userGroups, data) {
  // removes post objects based upon group
  return remove(data, item => {
      if (item.acf && item.acf.hasOwnProperty('user_groups')) {
        const checks = map(item.acf.user_groups, (groupId) => {
          const userGroupIds = Object.values(userGroups)
          return some(userGroupIds, group => {
            return group == groupId
          })
        })
        return (checks.length === 0 ) ? true : (checks.includes(true))
      } else {
        return true
      }
    })
}

function filterUserFunnels(userGroups, data) {
  // removes post objects based upon group
  forEach(data, item => {
    remove(item.children, child => {
      if (isArray(child.user_groups) && child.user_groups.length > 0) {
        const childCheck = map(child.user_groups, (groupId) => {
          const userGroupIds = Object.values(userGroups)
          return some(userGroupIds, group => {
            return group == groupId
          })
        })
        return (childCheck.length === 0 ) ? true : (!childCheck.includes(true))
      } else {
        return false
      }
    })
  })
  // remove group if group specified and it is not users group
  const output = remove(data, item => {
    if (isArray(item.user_groups) && item.user_groups.length > 0) {
      const checks = map(item.user_groups, (groupId) => {
        const userGroupIds = Object.values(userGroups)
        return some(userGroupIds, group => {
          return group == groupId
        })
      })
      return (checks.length === 0 ) ? true : (checks.includes(true))
    } else {
      return true
    }
  })
  return output;
}

export const getters = {
  ...CommonGetters,
  getAllSessions: state => {
    const sessionItemConfigs = pStore.apiRequests.filter(
      item => item.learningType == 'session',
    )
    const collection = []
    let i = 0
    do {
      const item = state[sessionItemConfigs[i].storeKey].data
      collection.push(item)
      i++
    } while (i < sessionItemConfigs.length)
    return collection.flat()
  },

  getBookmarks: state => {
    return state.bookmarks.data
  },

  getSearchResults: state => {
    return state.searchResults.data
  },

  searchResultsLoaded: (state) => {
    return state.searchResults.queryRun
  },

  postResultsLoaded: (state) => (postType) => {
    return state[postType].queryRun
  },

  getAllPosts: state => {
    const posts = pStore.apiRequests
    const collection = []
    let i = 0
    do {
      const item = state[posts[i].storeKey].data
      collection.push(item)
      i++
    } while (i < posts.length)
    return collection.flat()
  },

  findAllPostsByProp: (state, getters) => (array = [0], propKey = 'id') => {
    const collection = []
    let i = 0
    do {
      const item = getters['getAllPosts'].find(
        item => item[propKey] == array[i],
      )
      collection.push(typeof item != 'undefined' ? item : {})
      i++
    } while (i < array.length)
    return collection
  },

  getAllManditoryPosts: (state, getters) => {
    const { getAllPosts } = getters
    const output = getAllPosts.filter(item => {
      if (item.acf && item.acf.required == true) {
        return item
      }
    })
    return output
  },

  filterAllSessionsByProp: (state, getters) => (
    array = [0],
    propKey = 'id',
  ) => {
    const collection = []
    let i = 0
    do {
      const item = getters['getAllSessions'].find(
        item => item[propKey] == array[i],
      )
      collection.push(typeof item != 'undefined' ? item : {})
      i++
    } while (i < array.length)
    return collection
  },

  getCourseSessions: (state, getters) => (
    value,
    propKey = 'id',
  ) => {
    const course = getters['findItemByProp']('courses', value)
  },

  findFunnelsByProp: function(state) {
    return (stateProp, value, key = 'id') => {
      return state[stateProp].data.find(item => {
        return item[key] === value
      })
    }
  },

  getItemsPerPage: function(state) {
    return (stateProp) => {
      return state[stateProp]['per_page']
    }
  },

  getTotalPages: function(state) {
    return (stateProp) => {
      return state[stateProp].totalPages
    }
  },

  checkIfGetAllPostsTriggered: function(state) {
      return state['getAllPostRequestTriggered']
  }

}
